export default "__VITE_ASSET__BPdTaN2q__"